import React from 'react';
import {
  Input,
  InputGroup,
  InputGroupAddon,
  Button,
  FormFeedback,
} from 'reactstrap';

const QuantityInput = ({
  disabled,
  value,
  error,
  type,
  handleQuantityInput,
}) => {
  if (type === 'program' || type === 'event') {
    return (
      <div>
        <div className="text-gray font-weight-bold mb-2">Quantity</div>
        <InputGroup>
          <InputGroupAddon addonType="prepend">Qty</InputGroupAddon>
          <Input
            type="number"
            disabled={disabled}
            value={value}
            onChange={({ target }) => handleQuantityInput(target.value)}
          />
          <InputGroupAddon addonType="append">
            <Button color="primary" disabled style={{ width: '30px' }}>
              X
            </Button>
          </InputGroupAddon>
        </InputGroup>
        <FormFeedback invalid="true">*{error}</FormFeedback>
      </div>
    );
  }
  return null;
};

export default QuantityInput;
